import { Col, Label, ReactSelectBox } from "client/CommonComponents";

const Mower = (props?:any) => {
  const managedEquipmentValues = props?.managedEquipmentValues;
  const manufacturerDropDownList = props?.manufacturerDropDownList;
  const categoryDropdownList = props?.categoryDropdownList;
  const deckSizeDropDownList = props?.deckSizeDropDownList;
  const deckTypeDropDownList = props?.deckTypeDropDownList;
  const stateAvailabilityDropDownList = props?.stateAvailabilityDropDownList;
  const annualHoursDropDownList = props?.annualHoursDropDownList;
  const autonomousDropDownList = props?.autonomousDropDownList;
  const programStatusDropDownList = props?.programStatusDropDownList;
  const managedMowerRef =props?.managedMowerRef;
  const handleAvailabilityChanges = props?.handleAvailabilityChanges;
  const handleManufacturerChanges = props?.handleManufacturerChanges;
  const handleProgramStatusChanges = props?.handleProgramStatusChanges;
  const handleAnnualHoursChanges = props?.handleAnnualHoursChanges;
  const handleCategeoryChanges = props?.handleCategeoryChanges;
  const handleDeckSizeChanges = props?.handleDeckSizeChanges;
  const handleAutonomousChanges = props?.handleAutonomousChanges;
  const handleDeckTypeChanges = props?.handleDeckTypeChanges;

  return (<>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="Mower_Default_Label_9">State Availability</Label>
        <ReactSelectBox
          options={stateAvailabilityDropDownList}
          onChange={(item: any, e: any) => handleAvailabilityChanges(e, item,'stateAvailability')}
          value={managedEquipmentValues?.stateAvailability}
          selectRef={(element:any)=>managedMowerRef.current[1] = element}
         data-attribute="Mower_Default_SearchSelectBox_9" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="Mower_Default_Label_2_2">Manufacturer</Label>
        <ReactSelectBox
          options={manufacturerDropDownList}
          onChange={(item: any, e: any) => handleManufacturerChanges(e, item,'manufacturer')}
          value={managedEquipmentValues?.manufacturer}
          selectRef={(element:any)=>managedMowerRef.current[2] = element}
         data-attribute="Mower_Default_SearchSelectBox_10" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="Mower_Default_Label_3_2">Program Status</Label>
        <ReactSelectBox
          options={programStatusDropDownList}
          onChange={(item: any, e: any) => handleProgramStatusChanges(e, item,'programStatus')}
          value={managedEquipmentValues?.programStatus}
          selectRef={(element:any)=>managedMowerRef.current[3] = element}
         data-attribute="Mower_Default_SearchSelectBox_11" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="Mower_Default_Label_4_2">Annual Hours</Label>
        <ReactSelectBox
          options={annualHoursDropDownList}
          onChange={(item: any, e: any) => handleAnnualHoursChanges(e, item,'annualHours')}
          value={managedEquipmentValues?.annualHours}
          selectRef={(element:any)=>managedMowerRef.current[4] = element}
         data-attribute="Mower_Default_SearchSelectBox_12" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="Mower_Default_Label_5_2">Category</Label>
        <ReactSelectBox
          options={categoryDropdownList}
          onChange={(item: any, e: any) => handleCategeoryChanges(e, item,'category')}
          value={managedEquipmentValues?.category}
          selectRef={(element:any)=>managedMowerRef.current[5] = element}
         data-attribute="Mower_Default_SearchSelectBox_13" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="Mower_Default_Label_6_2">Deck Size</Label>
        <ReactSelectBox
          options={deckSizeDropDownList}
          onChange={(item: any, e: any) => handleDeckSizeChanges(e, item,'deckSize')}
          value={managedEquipmentValues?.deckSize}
          selectRef={(element:any)=>managedMowerRef.current[6] = element}
          isSearchable={true}
         data-attribute="Mower_Default_SearchSelectBox_14" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="Mower_Default_Label_7_2">Deck Type</Label>
        <ReactSelectBox
          options={deckTypeDropDownList}
          onChange={(item: any, e: any) => handleDeckTypeChanges(e, item,'deckType')}
          value={managedEquipmentValues?.deckType}
          selectRef={(element:any)=>managedMowerRef.current[7] = element}
         data-attribute="Mower_Default_SearchSelectBox_15" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="Mower_Default_Label_8_2">Autonomous</Label>
        <ReactSelectBox
          options={autonomousDropDownList}
          onChange={(item: any, e: any) => handleAutonomousChanges(e, item,'autonomous')}
          value={managedEquipmentValues?.autonomous}
          selectRef={(element:any)=>managedMowerRef.current[8] = element}
         data-attribute="Mower_Default_SearchSelectBox_16" />
      </Col>
  </>)
}

export default Mower;
